module.exports = __webpack_public_path__ + "img/logo_horizontal.8ad62db7.png";